import "./style.css";
import ReactDOM from "react-dom/client";
import { Canvas } from "@react-three/fiber";
import Experience from "./components/Experience.jsx";
import Controls from "./components/Controls.jsx";
import store from "./redux/store.jsx";
import { Provider } from "react-redux";
import { LinearToneMapping } from "three";
import Footer from "./components/Footer.jsx";
import RoofButton from "./components/RoofButton.jsx";
import { Expand, Shrink } from "lucide-react";
import { useRef, useState } from "react";
import { PerspectiveCamera } from "@react-three/drei";
import CaptureCamera from "./components/CaptureCamera.jsx";

const root = ReactDOM.createRoot(document.querySelector("#root"));

function App() {
    const [full, setFull] = useState(false);
    const cameraRef = useRef();

    return (
        <Provider store={store}>
            <div id="main" className={full ? "fullscreen" : ""}>
                {/* <img src="/images/logo.png" id="roomLogo" /> */}
                <Canvas
                    id="three"
                    gl={{ preserveDrawingBuffer: true }}
                    onCreated={({ gl }) => {
                        gl.toneMapping = LinearToneMapping;
                    }}
                >
                    <PerspectiveCamera
                        makeDefault
                        fov={45}
                        near={0.1}
                        far={2000}
                        zoom={.8}
                        position={[-3, 1.25, 4]}
                    />
                    <CaptureCamera ref={cameraRef}/>
                    <Experience />
                </Canvas>
                <RoofButton />
                <button className="fullscreen-button" onClick={() => setFull(!full)}>
                    {full ? <Shrink /> : <Expand />}
                </button>
                <Controls />
            </div>
            <Footer getImage={() => cameraRef.current?.getImage()} htmlClass={full ? "fullscreen" : ""} />
        </Provider>
    );
}

root.render(<App />);